import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { NatDateiTyp } from 'src/app/immutable/enums/nat-datei-typ';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { ConstantsSonstige } from 'src/app/immutable/constants-sonstige';
import { ConstantsTexte } from 'src/app/immutable/constants-texte';
import { FileType, GlobalFunctions } from 'globales-projekt-angular';

@Component({
  selector: 'app-quellen',
  templateUrl: './quellen.component.html',
  styleUrls: ['./quellen.component.css'],
})
export class QuellenComponent implements OnInit {
  anwendungsname = ConstantsTexte.ANWENDUNGSNAME;

  faArrowLeft = faArrowLeft;

  constructor(private apiService: ApiService, private location: Location) {}

  ngOnInit(): void {}

  downloadPdfAquakultur() {
    this.downloadPdf(
      NatDateiTyp.AQUAKULTUR,
      ConstantsSonstige.FILENAME_AQUAKULTUR
    );
  }

  downloadPdfGefluegel() {
    this.downloadPdf(
      NatDateiTyp.GEFLUEGEL,
      ConstantsSonstige.FILENAME_GEFLUEGEL
    );
  }

  downloadPdfRind() {
    this.downloadPdf(NatDateiTyp.RIND, ConstantsSonstige.FILENAME_RIND);
  }

  downloadPdfSchwein() {
    this.downloadPdf(NatDateiTyp.SCHWEIN, ConstantsSonstige.FILENAME_SCHWEIN);
  }

  downloadPdfSOE() {
    this.downloadPdf(NatDateiTyp.SOE, ConstantsSonstige.FILENAME_SOE);
  }

  downloadPdfTuS() {
    this.downloadPdf(NatDateiTyp.TUS, ConstantsSonstige.FILENAME_TUS);
  }

  downloadPdfSchatzi() {
    this.downloadPdf(NatDateiTyp.SCHATZI, ConstantsSonstige.FILENAME_SCHAF_ZIEGE);
  }

  downloadPdf(natDateiTyp: NatDateiTyp, pdfName: string) {
    this.apiService.getPdf(natDateiTyp).subscribe((response) => {
      GlobalFunctions.downloadFile(FileType.PDF, response, pdfName, FileType.PDF_SHORT);
    });
  }

  goBack() {
    this.location.back();
  }
}
